import React, { useState, useEffect } from "react";
import { Loader, Pagination, Button } from "semantic-ui-react";
import { map, size } from "lodash";
import { StudentAPI, InstitutionApi } from "../../../../api";
import { StudentItem } from "../StudentItem";
import { useTranslation } from "react-i18next";
import "./StudentList.scss";

const studentController = new StudentAPI();
const institutionController = new InstitutionApi();

export function StudentList(props) {
  const { user, accessToken, reload, onReload } = props;
  const { t } = useTranslation("students");
  const [students, setStudents] = useState(null);
  const [filteredStudents, setFilteredStudents] = useState(null); // Lista filtrada
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [institution, setInstitution] = useState(null); // Para obtener classnumber
  const [selectedClass, setSelectedClass] = useState(null); // Clase seleccionada

  // Obtener datos de la institución
  useEffect(() => {
    const fetchInstitution = async () => {
      try {
        const response =
          await institutionController.getInstitutionsbyInstitution(
            accessToken,
            user.user.institutions[0],
            true,
          );
        setInstitution(response.institution);
      } catch (error) {
        console.error("Error al obtener institución:", error);
      }
    };
    fetchInstitution();
  }, [accessToken, user.user.institutions]);

  // Obtener estudiantes
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await studentController.getStudents(
          accessToken,
          user.user.institutions[0],
          { page },
        );
        setStudents(response.students);
        setFilteredStudents(response.students); // Inicialmente sin filtros
        setPagination({
          total: response.pagination.totalDocs,
          page: response.pagination.page,
          limit: response.pagination.limit,
          totalPages: response.pagination.totalPages,
        });
      } catch (error) {
        console.error("Error al obtener estudiantes:", error);
      }
    };
    fetchStudents();
  }, [page, user.user.institutions, reload, accessToken]);

  // Filtrar estudiantes por classnumber
  const filterByClass = (classnumber) => {
    setSelectedClass(classnumber); // Guardar clase seleccionada
    if (classnumber) {
      const filtered = students.filter(
        (student) => student.classnumber === classnumber,
      );
      setFilteredStudents(filtered);
    } else {
      setFilteredStudents(students); // Resetear filtro si no hay clase seleccionada
    }
  };

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!students || !institution) return <Loader active inline="centered" />;

  return (
    <div className="student-list-container">
      {/* Botones de filtro por classnumber */}
      <div className="class-filter-buttons">
        <Button
          onClick={() => filterByClass(null)}
          className={!selectedClass ? "primary" : ""}
        >
          {t("list.showAll")}
        </Button>
        {institution?.classnumber?.map((classnumber) => (
          <Button
            key={classnumber}
            onClick={() => filterByClass(classnumber)}
            className={selectedClass === classnumber ? "primary" : ""}
          >
            {classnumber}
          </Button>
        ))}
      </div>

      {/* Mensaje si no hay estudiantes */}
      {size(filteredStudents) === 0 ? (
        <h2 className="no-students-message">{t("list.noStudents")}</h2>
      ) : (
        <div className="list-student">
          {map(filteredStudents, (student) => (
            <StudentItem
              key={student._id}
              accessToken={accessToken}
              institution={user.user.institutions[0]}
              student={student}
              onReload={onReload}
            />
          ))}
        </div>
      )}

      {/* Paginación */}
      {size(filteredStudents) > 0 && (
        <div className="list-student__pagination">
          <Pagination
            defaultActivePage={pagination?.page || 1}
            totalPages={pagination?.totalPages || 1}
            ellipsisItem={null}
            firstItem={null}
            lastItem={null}
            onPageChange={changePage}
          />
        </div>
      )}
    </div>
  );
}
